import { Card, Grid, Tab, Tabs } from "@mui/material";
import React, { SyntheticEvent, useState } from "react";
import Layout from "components/Layout";
import Strategy from "components/holdings/Management/Strategy";
import StateTaxRates from "components/holdings/Management/StateTaxRates";

const ManagementPage = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (_event: SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <Layout title="Management">
      <Card>
        <Tabs value={activeTab} onChange={handleTabChange}>
          <Tab label="Strategy" />
          <Tab label="State Tax Rates" />
        </Tabs>
        <Grid container>
          {activeTab === 0 && (
            <Grid item xs={12} padding={2}>
              <Strategy />
            </Grid>
          )}
          {activeTab === 1 && (
            <Grid item xs={12} padding={2}>
              <StateTaxRates />
            </Grid>
          )}
        </Grid>
      </Card>
    </Layout>
  );
};

export default ManagementPage;
